/** WCAG 2.5.5 minimum target size. */
export const MIN_TAP_TARGET_PX = 44;

/** Body text minimum for legible reading (WCAG-aligned, common default). */
export const MIN_BODY_FONT_SIZE_PX = 14;

/** Heading minimum (WCAG suggests headings should be visibly larger than body). */
export const MIN_HEADING_FONT_SIZE_PX = 18;

/** WCAG 2.1 contrast targets. */
export const CONTRAST = {
  AAA: 7,
  AA: 4.5,
  A: 3
} as const;

export type WcagTarget = keyof typeof CONTRAST;

export function isTouchTargetSized(width: number, height: number): boolean {
  return width >= MIN_TAP_TARGET_PX && height >= MIN_TAP_TARGET_PX;
}
